import React from 'react';
import PropTypes from 'prop-types';

export function OptionFeedback(props) {
  if (props.visible) {
    return <p className={props.type}>{props.text}</p>;
  } else {
    return null;
  }
}

OptionFeedback.propTypes = {
  /**
   * Boolean specifying if feedback is visible
   */
  visible: PropTypes.bool.isRequired,
  /**
   * String specifying type of feedback [correct/incorrect]
   */
  type: PropTypes.oneOf(['correct', 'incorrect']).isRequired,
  /**
   * text to be displayed as feedback
   */
  text: PropTypes.string.isRequired,
};

OptionFeedback.defaultProps = {
  visible: false,
  type: 'incorrect',
  text: '',
};
